import { Outlet } from 'react-router-dom';

import { ClerkAuthGate } from '@/auth/clerk/components/ClerkAuthGate';
import { AUTH_MODE } from '@/auth/constants/AuthMode';

// With the mock sign-in the server signs every request in: nothing to wait
// for before loading the session.
export const AuthGate = () =>
  AUTH_MODE === 'clerk' ? <ClerkAuthGate /> : <Outlet />;
